import React, { type ReactNode } from 'react';

import AttentionIcon from '../../../../../assets/icons/AttentionIcon';
import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import styles from '../textField.module.scss';

/** Custom props */
export type TextfieldErrorProps = {
  /** The content of the component */
  children?: ReactNode;

  /** Custom class to overwrite default styling if needed */
  className?: string;

  /** Style name to control the appearance of Alert title */
  errorTitleClassname?: string;

  /** Style name to control the appearance of Alert icon */
  errorIconClassName?: string;

  /** Flag to indicate if the error message should be shown */
  hasError: boolean;

  errorId?: string;
  /** Flag to indicate if the error icon should be shown */
  isAttentionIconVisible?: boolean;
};

export function Error(props: TextfieldErrorProps) {
  const {
    children,
    className,
    errorTitleClassname,
    errorIconClassName,
    hasError,
    errorId,
    isAttentionIconVisible = true,
  } = props;

  const classNames = cx(
    styles[toCamelCase('textField', 'errorMessage')],
    hasError && styles[toCamelCase('textField', 'errorMessage', 'show')],
    className,
  );
  return (
    <div className={classNames}>
      {isAttentionIconVisible && (
        <AttentionIcon
          size={16}
          className={cx(styles[toCamelCase('textField', 'errorIcon')], errorIconClassName)}
        />
      )}
      <span className={errorTitleClassname} data-testid="textField-error" id={errorId}>
        {children}
      </span>
    </div>
  );
}

export default Error;
